import { Button, ModalProps } from "antd";
import React, { useState } from "react";
import styles from "./styles.module.scss";
import CustomModal from "../../commons/components/CustomModal/CustomModal";
import CustomInput from "../../commons/components/CustomInput/CustomInput";
import { ColumnsType } from "antd/es/table";
import CustomPagination from "../../commons/components/CustomPagination";
import CustomTable from "../../commons/components/CustomTable";
import useTable from "../../commons/hooks/useTable";
import useFetchList from "../../commons/hooks/useFetchList";
import { LIST_PRODUCT_IN_MENU } from "../../commons/constants/api-urls";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import GradientText from "../../commons/components/GradientText/GradientText";
interface Props extends ModalProps {
  title?: string;
  menuName?: string;
  product?: any;
  storeId: string;
  group: GroupMenuList;
  navigate: (groupId: string, groupName: string) => void;
  onClose: () => void;
}

const ModalPreviewGroupMenu: React.FC<Props> = ({
  onCancel,
  group,
  storeId,
  menuName,
  title,
  product,
  onClose,
  navigate,
  ...modalProps
}) => {
  const [keyword, setKeyword] = useState("");
  const { page, setPage, onShowSizeChange, perPage } = useTable();
  const { data, total, refresh, loading, setLoading } = useFetchList<GroupMenuList>(
    LIST_PRODUCT_IN_MENU(storeId, group.id),
    {
      page,
      perPage,
      paginationMetadataStyle: "body",
      keyword: keyword.trim(),
    }
  );

  const columns: ColumnsType<GroupMenuList> = [
    {
      title: "Product Name",
      dataIndex: "name",
      render: (text, record, index) => {
        return text;
      },
    },
    {
      title: "Product ID ",
      dataIndex: "id",
      render: (text, record, index) => {
        return text;
      },
    },
  ];
  return (
    <CustomModal className={styles.modalGroupMenu} {...modalProps}>
      <div className={styles.title}>{title}</div>
      <div className={styles.menuName}>{menuName}</div>

      <div className={styles.searchBox}>
        <CustomInput
          className={styles.inputSearch}
          type="search"
          placeholder="Search for product name, ID"
          onChange={e => {
            setKeyword(e.target.value);
          }}
        />
      </div>

      <div className={styles.menuPanel}>
        <div className={styles.paginationWrapper}>
          <p></p>
          <CustomPagination
            defaultCurrent={1}
            showSizeChanger
            current={page}
            onChange={page => setPage(page)}
            total={total}
            onShowSizeChange={onShowSizeChange}
            pageSize={perPage}
          />
        </div>
        <CustomTable loading={loading} pagination={false} columns={columns} dataSource={data} scroll={{ x: 400 }} />
      </div>
      <div className={styles.btnBox}>
        <PrimaryButton onClick={() => navigate(group.id, group.name)}>Edit</PrimaryButton>
        <div className={styles.btnCancel} onClick={onClose}>
          <GradientText text={"Cancel"}></GradientText>
        </div>
      </div>
    </CustomModal>
  );
};

export default ModalPreviewGroupMenu;
